export class LoadAccountingUnits {
    static readonly type = '[Accounting Unit] Load Accounting Units';

    constructor(
        public page?: number,
        public pageSize?: number
    ) {}
}
